import { DocumentView } from './DocumentView';
import TableView from '@/components/folders/TableView';
import { Documentcolumn } from '@/components/columns/DocumentsColumn';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { User } from '@/types';
import { Button, Dropdown } from 'antd';
import { DocumentModal } from '@/utils/enums';
import { getDocumentMenu } from '@/components/menu';
import { useTranslation } from 'react-i18next';
import useMomentWithTimezone from '@/hooks/timezone';
import {
  isSystemAdmin,
  canUploadFileToFolder,
  canEditDefaultFolders,
} from '@/utils/helpers';
import { useState } from 'react';

const ActionDropdown = ({
  node,
  t,
  setOpenModal,
  setCurrentNode,
  setNodeToDelete,
  setNodeToEdit,
  setNodeToMove,
  canEditDefault,
}: {
  node: any;
  t: any;
  setOpenModal: any;
  setCurrentNode: any;
  setNodeToDelete?: any;
  setNodeToEdit?: any;
  setNodeToMove?: any;
  canEditDefault?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const menu = getDocumentMenu(
    t,
    setOpenModal,
    node,
    setCurrentNode,
    () => setOpen(false),
    setNodeToDelete,
    setNodeToEdit,
    setNodeToMove,
    canEditDefault,
  );
  return (
    <Dropdown
      menu={menu}
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
    >
      <a>
        <img
          alt=""
          width={20}
          height={20}
          src={'/icons/more_action.svg'}
          style={{ color: 'blue' }}
        />
      </a>
    </Dropdown>
  );
};

export default function RightSidebar({
  documentView,
  currentNode,
  setCurrentNode,
  usersInDocuments,
  setUsersInDocuments,
  onExpand,
  setOpenModal,
  user,
  setNodeToDelete,
  setNodeToEdit,
  setNodeToMove,
}: {
  documentView: DocumentView;
  currentNode: any;
  setCurrentNode: any;
  usersInDocuments: any;
  setUsersInDocuments: any;
  onExpand: any;
  setOpenModal: any;
  user: User | null;
  setNodeToDelete?: any;
  setNodeToEdit?: any;
  setNodeToMove?: any;
}) {
  const { t } = useTranslation();
  const momentWithTimezone = useMomentWithTimezone();
  return (
    <TableView
      tableData={documentView.tableData}
      currentNode={currentNode}
      setCurrentNode={setCurrentNode}
      usersInDocuments={usersInDocuments}
      setUsersInDocuments={setUsersInDocuments}
      columns={[
        ...(Documentcolumn(
          t,
          onExpand,
          isSystemAdmin(user),
          momentWithTimezone,
        ) as any),
        {
          title: t('home.documents.table.download'),
          key: 'path',
          render: node =>
            node?.path ? (
              <a href={node.path} target="_blank" rel="noopener noreferrer">
                <DownloadOutlined />
              </a>
            ) : null,
        },
        {
          title: t('home.documents.table.action'),
          key: 'action',
          render: node => {
            const canEditDefault = canEditDefaultFolders(user);
            return (
              <ActionDropdown
                node={node}
                t={t}
                setOpenModal={setOpenModal}
                setCurrentNode={setCurrentNode}
                setNodeToDelete={setNodeToDelete}
                setNodeToEdit={setNodeToEdit}
                setNodeToMove={setNodeToMove}
                canEditDefault={canEditDefault}
              />
            );
          },
        },
      ]}
      onExpand={onExpand}
      button={
        <Button
          icon={<UploadOutlined />}
          type="primary"
          onClick={() => setOpenModal(DocumentModal.ADD_FILE)}
          disabled={!canUploadFileToFolder(user, currentNode)}
        >
          {t('home.documents.upload')}
        </Button>
      }
    />
  );
}
